import { computed, inject } from 'vue';
import { useRouter } from 'vue-router';

// CONFIG
import { transactionProviderKey as transactionProvider,
  initialValuesTransactionProvider,
} from '@/modules/transaction/constants/transactionProvider.constant';

// TYPES
import type { RouteProductType } from '@/types/RouteTransferType';
import type { SuccessPreTransactionProps } from '../../types/successPreTransaction.type';

export function useSuccessPreTransaction(props: SuccessPreTransactionProps) {
  const {
    preTransactionResponse,
    transactionPayload,
    quoteData,
    isComexFlow,
    purposeSelected,
    selectedPurposesComex,
  } = inject(transactionProvider, initialValuesTransactionProvider);

  const router = useRouter();

  const currencyProductType = computed((): RouteProductType => {
    return props.successType === 'P2P' || props.successType === 'P2P_COMEX'
      ? 'P2P'
      : 'REMITTANCE';
  });

  const onHome = () => {
    router.push({ name: 'movements' });
  };

  return {
    preTransactionResponse,
    transactionPayload,
    quoteData,
    isComexFlow,
    purposeSelected,
    selectedPurposesComex,
    currencyProductType,
    onHome,
  };
}
